import { textStyles } from "@looksrare/chakra-theme";

const lineVariant = {
  tab: {
    borderColor: "transparent",
    color: "text-03",
    _hover: {
      color: "link-02",
      borderColor: "text-disabled",
    },
    _active: {
      backgroundColor: "transparent",
    },
    _selected: {
      color: "text-01",
      borderColor: "interactive-03",
    },
  },
  tablist: {
    borderBottomColor: "border-01",
    borderBottomWidth: "1px",
    paddingBottom: "1px",
  },
};

const blankVariant = {
  tab: {
    ...lineVariant.tab,
    borderBottomWidth: "2px",
    borderColor: "transparent",
  },
};

const enclosedVariant = {
  tab: {
    bg: "ui-01",
    borderBottom: 0,
    borderRadius: "square",
    borderLeft: 0,
    borderRight: 0,
    mb: 0,
    _selected: {
      bg: "ui-bg",
      borderBottom: 0,
      borderLeft: 0,
      borderRight: 0,
      borderTop: "2px solid",
      borderTopColor: "interactive-01",
      color: "text-01",
      _hover: {
        bg: "hover-ui",
      },
      _active: {
        bg: "onclick-ui",
      },
    },
    _active: {
      bg: "onclick-ui",
    },
    _hover: {
      bg: "hover-ui",
    },
  },
  tablist: {
    border: 0,
    mb: 0,
  },
};

const enclosedInvertedVariant = {
  ...enclosedVariant,
  tab: {
    ...enclosedVariant.tab,
    borderTopWidth: "2px",
    borderTopColor: "ui-bg",
    bg: "ui-bg",
    _hover: {
      bg: "hover-ui",
      borderTopColor: "hover-ui",
    },
    _selected: {
      ...enclosedVariant.tab._selected,
      bg: "ui-01",
      _hover: {
        bg: "hover-ui",
        borderTopColor: "interactive-01",
      },
    },
  },
};

export const TabsTheme = {
  sizes: {
    md: {
      tab: {
        minHeight: 12,
        fontSize: textStyles.body.fontSize,
      },
    },
  },
  baseStyle: {
    tab: {
      whiteSpace: "nowrap",
      fontWeight: "bold",
      color: "text-02",
    },
    root: {
      scrollbarWidth: "none",
      "&::-webkit-scrollbar": {
        display: "none",
      },
      overflowX: "auto",
    },
    tablist: {
      minWidth: "fit-content",
    },
  },
  variants: {
    line: lineVariant,
    blank: blankVariant,
    enclosed: enclosedVariant,
    "enclosed-inverted": enclosedInvertedVariant,
  },
  defaultProps: {
    colorScheme: "green",
  },
};
